import React from "react";

export default function About() {
  const card = {
    maxWidth: 980,
    margin: "0 auto",
    borderRadius: 18,
    padding: "18px 16px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(0,0,0,0.55)",
    boxShadow: "0 22px 70px rgba(0,0,0,0.60)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
  };

  const h1 = { margin: 0, fontSize: 28, fontWeight: 900, letterSpacing: 0.2 };
  const p = { marginTop: 10, color: "rgba(255,255,255,0.86)", lineHeight: 1.55 };
  const sub = { marginTop: 14, fontSize: 16, fontWeight: 900 };

  return (
    <div style={card}>
      <h1 style={h1}>About GAStreaming</h1>
      <div style={{ marginTop: 6, color: "rgba(255,255,255,0.70)", fontSize: 13 }}>
        Last updated: January 1, 2026
      </div>

      <p style={p}>
        GAStreaming (Get Active Streaming) is a community-first streaming platform where you can watch live
        streams, explore VODs, interact through chat, and support creators.
      </p>

      <div style={sub}>What you can do here</div>
      <ul style={{ marginTop: 8, paddingLeft: 18, color: "rgba(255,255,255,0.86)", lineHeight: 1.55 }}>
        <li>Watch live streams and browse channels</li>
        <li>Discover VODs and community uploads (where available)</li>
        <li>Chat and participate in community features</li>
        <li>Support the platform and creators through donations, subscriptions, and merch</li>
      </ul>

      <div style={sub}>Our goal</div>
      <p style={p}>
        We’re building an owned-and-operated streaming destination with a clean, mobile-friendly experience and a
        strong focus on creator support.
      </p>
    </div>
  );
}
